import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {gettext} from '../translations';

import {constants as destinationConstants} from '@eb/destination-utils';

import {getAttributionForImage} from '../utils/background';
import {getHeroImageIndex} from '../utils/localStorage';

import HeaderBackground from './HeaderBackground';
import MadLibs from './MadLibs';

import './Header.scss';

const {LOCATION_DIALOG_CONTENT} = destinationConstants;

export default class Header extends PureComponent {
    static propTypes = {
        handleUseCurrentLocation: PropTypes.func.isRequired,
        handleMadLibsSearch: PropTypes.func.isRequired,
        locationDenied: PropTypes.bool,
        shouldShowSearchAnimation: PropTypes.bool,
        showOverlay: PropTypes.func,
        hideOverlay: PropTypes.func,
        addOverlayNotification: PropTypes.func,
        isMobile: PropTypes.bool,
        currentHeroImage: PropTypes.number,
        // eslint-disable-next-line
        history: PropTypes.object,
    }

    state = {
        imageAttribution: '',
    }

    componentDidMount() {
        this.setState({
            imageAttribution: getAttributionForImage({imageIndex: getHeroImageIndex()}),
        });
    }

    componentDidUpdate(prevProps) {
        const {
            locationDenied,
            showOverlay,
        } = this.props;

        if (locationDenied !== prevProps.locationDenied && showOverlay) {
            showOverlay(
                'dialog',
                LOCATION_DIALOG_CONTENT
            );
        }
    }

    render() {
        const {
            handleUseCurrentLocation,
            handleMadLibsSearch,
            locationDenied,
            shouldShowSearchAnimation,
            showOverlay,
            hideOverlay,
            isMobile,
            history,
        } = this.props;
        const {imageAttribution} = this.state;

        const feedHeaderClassNames = classNames([
            'feed-header',
            'eds-l-mn-pad-hor-3',
            'eds-l-md-pad-hor-3',
            'eds-l-mw-pad-hor-3',
            'eds-l-ln-pad-hor-3',
            'eds-l-lg-pad-hor-3',
            'eds-l-lw-pad-hor-3',
        ]);

        const title = gettext('<div class="feed-header__title-top">Made for</div><div class="feed-header__title-bottom">those who do</div>');
        // eslint-disable-next-line react/no-danger
        const titleComponent = (<h1 className="feed-header__title eds-text-color--white" dangerouslySetInnerHTML={{__html: title}} />);
        // const imageAttribution = getAttributionForImage({imageIndex: getHeroImageIndex()});

        let imageAttributionComponent = null;

        if (imageAttribution) {
            imageAttributionComponent = (
                <div className="feed-header__attribution eds-text-bs">
                    {imageAttribution}
                </div>
            );
        }

        return (
            <section className={feedHeaderClassNames}>
                <HeaderBackground type="MainHeaderBackgroundBlur" />
                <HeaderBackground type="MainHeaderBackground" />

                <div className="feed-header__content eds-text-color--white">
                    <div className="eds-g-cell eds-g-cell-12-12 eds-g-cell-sw-6-12 eds-g-cell-mn-7-12 eds-g-cell-md-8-12">
                        {titleComponent}
                    </div>
                    <div className="eds-g-cell eds-g-cell-12-12 eds-g-cell-sw-6-12 eds-g-cell-mn-5-12 eds-g-cell-md-4-12 eds-g-cell--has-overflow">
                        <MadLibs
                            handleUseCurrentLocation={handleUseCurrentLocation}
                            handleMadLibsSearch={handleMadLibsSearch}
                            locationDenied={locationDenied}
                            showOverlay={showOverlay}
                            hideOverlay={hideOverlay}
                            isMobile={isMobile}
                            shouldShowSearchAnimation={shouldShowSearchAnimation}
                            history={history}
                        />
                    </div>

                    {imageAttributionComponent}
                </div>
            </section>
        );
    }
}
